/** @param {string} url */
export default function isInternalLink(url) {
  if (/^\/(?!\/)/.test(url)) {
    return url;
  }

  if (/^(https?:)?\/\/(((beta)|(www))\.)?farmersfridge\.com/.test(url)) {
    return url.split('farmersfridge.com')[1] || '/';
  }

  return null;
}
